import { crimson } from './fonts'

type Props = {
  email: string
}

export function DeluxeSignupLoggedInMessage({ email }: Props) {
  return (
    <p className={`${crimson.className} text-center text-[#5a4a3a] mb-6`}>
      You&apos;re signed in as{' '}
      <span className="font-semibold text-[#2c1810]">{email}</span>. Tap below
      to get deluxe edition notifications on this account.
    </p>
  )
}
